import { render, staticRenderFns } from "./enterpriseNew.vue?vue&type=template&id=631a906b&scoped=true"
import script from "./enterpriseNew.vue?vue&type=script&lang=js"
export * from "./enterpriseNew.vue?vue&type=script&lang=js"
import style0 from "./enterpriseNew.vue?vue&type=style&index=0&id=631a906b&lang=scss&scoped=true"
import style1 from "./enterpriseNew.vue?vue&type=style&index=1&id=631a906b&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631a906b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('631a906b')) {
      api.createRecord('631a906b', component.options)
    } else {
      api.reload('631a906b', component.options)
    }
    module.hot.accept("./enterpriseNew.vue?vue&type=template&id=631a906b&scoped=true", function () {
      api.rerender('631a906b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/page/enterpriseNew.vue"
export default component.exports